import { Box, Flex } from "@rebass/grid";
import { IContract } from "@rentiohq/shared-frontend/dist/types/contract.types";
import { formatAddress } from "@rentiohq/shared-frontend/dist/utils/address.utils";
import { Button, Icon, ESpacings } from "@rentiohq/web-shared/dist/components";
import { useNavigate } from "react-router-dom";

interface IProps {
  contract: IContract;
}

export const LinkedProperties = ({ contract }: IProps) => {
  const navigate = useNavigate();
  return (
    <>
      {contract.linkedProperties?.map((property, index) => (
        <Flex
          alignItems="center"
          mb={index ? ESpacings.tight : 0}
          key={property.id}
        >
          <Icon size="small" source="hyperlinkBold" color="neutral60" />
          <Box flex="1" ml={ESpacings.tight}>
            <Button
              appearance="link"
              onClick={() => navigate(`/properties/${property.id}`)}
            >
              {formatAddress(property, true, true, false)}
            </Button>
          </Box>
        </Flex>
      ))}
    </>
  );
};
